import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
// import { ApiEndPointUrl } from '@fuse/utils/systemEnums';
import { CommonService } from '@fuse/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AddTicketTypeService {

  constructor(
    private _fuseProgressBarService:FuseProgressBarService,
    private _http:HttpClient,
    private _matSnackBar:MatSnackBar,
    private _commonService:CommonService
  ) { }

  addTicketType(data) {

    // const formData  =new FormData();
    // formData.append('title',data.typeName)
    // formData.append('description',data.desc)
    // formData.append('icon',data.icon)

    const payload = {
      title : data.typeName,
      description : data.desc,
      icon : data.icon
    }


    this._fuseProgressBarService.show()
    return new Promise((resolve, reject) => {
      this._http.post(environment.apiURL + 'admin/tickets/add/type', payload, this._commonService.getHeader()).subscribe((result: any) => {
        this._fuseProgressBarService.hide()
        if (result.status = 200) {
          resolve(result)
        }
        this._matSnackBar.open(result.message, 'OK', {
          verticalPosition: "bottom",
          duration: 2000
        })
      }, reject)
    })
  }

  editTicketType(data, id) {
    
    const payload = {
      typeId : id,
      title : data.typeName,
      description : data.desc,
      icon : data.icon
    }

    // const formData  =new FormData();
    // formData.append('title',data.typeName)
    // formData.append('description',data.desc)
    // formData.append('icon',data.icon)
    // formData.append('typeId',id)

    this._fuseProgressBarService.show()
    return new Promise((resolve, reject) => {
      this._http.put(environment.apiURL + 'admin/tickets/updateadd/type', payload, this._commonService.getHeader()).subscribe((result: any) => {
        this._fuseProgressBarService.hide()
        if (result.status = 200) {
          resolve(result)
        }
        this._matSnackBar.open(result.message, 'OK', {
          verticalPosition: "bottom",
          duration: 2000
        })
      }, reject)
    })
  }
 
}
